import { apiClient } from './api';
import { Partner } from '../types';

class PartnerService {
  async getAllPartners(): Promise<Partner[]> {
    return apiClient.get<Partner[]>('/admin/partners');
  }

  async createPartner(data: Partial<Partner>): Promise<Partner> {
    return apiClient.post<Partner>('/admin/partners', data);
  }

  async updatePartner(id: string, data: Partial<Partner>): Promise<Partner> {
    return apiClient.put<Partner>(`/admin/partners/${id}`, data);
  }
}

export const partnerService = new PartnerService();
